import * as Immutable from 'immutable';

import { EXTERNAL_DATA_LAKE_QUERY_TYPE } from 'data-lake/preview/Constants';

export const EXTERNAL_DATA_LAKE_STORAGE_TYPE_TRINO = 'TRINO' as const;
export const EXTERNAL_DATA_LAKE_STORAGE_TYPE_ATHENA = 'ATHENA' as const;

export const EXTERNAL_DATA_LAKE_QUERY = {
  type: EXTERNAL_DATA_LAKE_QUERY_TYPE,
  query_string: '',
} as const;

export const DEFAULT_FIELDS = Immutable.OrderedSet([
  'time_dt',
  'severity',
  'category_name',
  'class_name',
  'activity_name',
  'accountid',
]);
